var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5479 14.375C13.1357 14.375 14.4229 13.0878 14.4229 11.5C14.4229 9.91218 13.1357 8.625 11.5479 8.625C9.96003 8.625 8.67285 9.91218 8.67285 11.5C8.67285 13.0878 9.96003 14.375 11.5479 14.375Z",
    stroke: "#002A58",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96432 12.3433V10.6566C1.96432 9.65996 2.77891 8.83579 3.78516 8.83579C5.51974 8.83579 6.22891 7.60913 5.35682 6.10454C4.85849 5.24204 5.15557 4.12079 6.02766 3.62246L7.68557 2.67371C8.44266 2.22329 9.42016 2.49163 9.87057 3.24871L9.97599 3.43079C10.8385 4.93538 12.2568 4.93538 13.1289 3.43079L13.2343 3.24871C13.6847 2.49163 14.6622 2.22329 15.4193 2.67371L17.0772 3.62246C17.9493 4.12079 18.2464 5.24204 17.7481 6.10454C16.876 7.60913 17.5852 8.83579 19.3197 8.83579C20.3164 8.83579 21.1406 9.65038 21.1406 10.6566V12.3433C21.1406 13.34 20.326 14.1641 19.3197 14.1641C17.5852 14.1641 16.876 15.3908 17.7481 16.8954C18.2464 17.7675 17.9493 18.8791 17.0772 19.3775L15.4193 20.3262C14.6622 20.7766 13.6847 20.5083 13.2343 19.7512L13.1289 19.5691C12.2664 18.0645 10.8481 18.0645 9.97599 19.5691L9.87057 19.7512C9.42016 20.5083 8.44266 20.7766 7.68557 20.3262L6.02766 19.3775C5.15557 18.8791 4.85849 17.7579 5.35682 16.8954C6.22891 15.3908 5.51974 14.1641 3.78516 14.1641C2.77891 14.1641 1.96432 13.34 1.96432 12.3433Z",
    stroke: "#002A58",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.01a2c5a804931e6e3b2a57d176940212.svg";
export { ForwardRef as ReactComponent };